import { feedApi } from './client';
import type { FeedResponse, SummaryResponse } from '@/types';

export const feedService = {
  async getFeed(params?: {
    limit?: number;
    offset?: number;
    lang?: string;
    category?: string;
  }): Promise<FeedResponse> {
    const response = await feedApi.get<FeedResponse>('/feed', { params });
    return response.data;
  },

  async getPersonalizedFeed(params?: {
    limit?: number;
    offset?: number;
    lang?: string;
    category?: string;
    task_id?: string;
  }): Promise<FeedResponse> {
    const response = await feedApi.get<FeedResponse>('/feed/personalized', {
      params,
    });
    return response.data;
  },

  async searchFeed(params: {
    q: string;
    lang?: string;
    limit?: number;
    offset?: number;
  }): Promise<FeedResponse> {
    const response = await feedApi.get<FeedResponse>('/feed/search', {
      params,
    });
    return response.data;
  },

  async summarize(
    url: string,
    lang?: string,
    title?: string
  ): Promise<SummaryResponse> {
    const response = await feedApi.post<SummaryResponse>('/feed/summarize', {
      url,
      lang,
      title,
    });
    return response.data;
  },
};

export default feedService;
